import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { RegistrationType } from 'src/app/shared/types/registration.type';
import { RegistrationAction } from './registration.action';
import { RegistrationService } from 'src/app/services/registration/registration.service';

@State<RegistrationType>({
  name: 'registration',
  defaults: {
    registerInfo: null,
    isLoading: false,
  },
})
@Injectable()
export class RegistrationState {
  static getRegisterInfo = () =>
    createSelector(
      [RegistrationState],
      (state: RegistrationType) => state.registerInfo
    );

  static getIsLoading = () =>
    createSelector(
      [RegistrationState],
      (state: RegistrationType) => state.isLoading
    );

  constructor(private service: RegistrationService) {}

  @Action(RegistrationAction.Register)
  register(
    ctx: StateContext<RegistrationType>,
    action: RegistrationAction.Register
  ) {
    return this.service.register(action.body);
  }

  @Action(RegistrationAction.RegisterConfirm)
  registerConfirm(
    ctx: StateContext<RegistrationType>,
    action: RegistrationAction.RegisterConfirm
  ) {
    return this.service.registerConfirm(action.body);
  }

  @Action(RegistrationAction.VerifyToken)
  verifyToken(
    ctx: StateContext<RegistrationType>,
    action: RegistrationAction.VerifyToken
  ) {
    return this.service.verifyToken(action.token).pipe(tap((_) => {}));
  }

  // @Action(AuthAction.CreateAccount)
  // createAccount(
  //   ctx: StateContext<RegistrationType>,
  //   action: AuthAction.CreateAccount
  // ) {
  //   return this.service.createAccount(action.body).pipe(tap((_) => {}));
  // }

  @Action(RegistrationAction.GetRegisterInfo)
  getRegisterInfo(
    ctx: StateContext<RegistrationType>,
    action: RegistrationAction.GetRegisterInfo
  ) {
    ctx.patchState({ isLoading: true });

    return this.service.getRegisterInfo().pipe(
      tap((list) => ctx.patchState({ registerInfo: list, isLoading: false })),
      catchError((error) => {
        ctx.patchState({ isLoading: false });
        return throwError(() => error);
      })
    );
  }
}
